import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaThLarge, FaBoxOpen, FaTools, FaUsers } from "react-icons/fa";
import { FiActivity } from "react-icons/fi";
import { IoMdTrendingUp } from "react-icons/io";
import { FiSettings, FiLogOut, FiUser } from "react-icons/fi";

const tabs = [
  { to: "/homePage", label: "Overview", icon: <FaThLarge /> },
  { to: "/machinePage", label: "Machines", icon: <FiActivity /> },
  { to: "/SalesPage", label: "Sales", icon: <IoMdTrendingUp /> },
  { to: "/inventoryPage", label: "Inventory", icon: <FaBoxOpen /> },
  { to: "/maintenancePage", label: "Maintenance", icon: <FaTools /> },
  { to: "/usersPage", label: "Users", icon: <FaUsers /> },
];

export default function Header() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const role = localStorage.getItem("role");

  const filteredTabs = tabs.filter((tab) => {
    if (role === "superadmin") return true;
    if (role === "admin") return true;
    return true;
  });

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };
  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-start gap-3 mb-2">
        <img
          className="h-20 w-20"
          src="/SVLogo.png"
          alt="Smartshake Logo"
        />

        <div className="flex-1">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-green-400 text-center sm:text-left uppercase mt-3">
            Smartshake Control Center
          </h1>

          <p className=" mt-1 text-sm sm:text-base text-center sm:text-left">
            Real-time vending machine monitoring & management
          </p>
        </div>

        <div className="relative ml-auto flex items-center gap-4 p-6">
          <div
            onClick={() => setOpen(!open)}
            className="flex items-center gap-2 cursor-pointer text-gray-400 hover:text-green-400 select-none transition-colors"
          >
            <FiSettings size={20} />
            <span className="hidden sm:block">Settings</span>
          </div>

          {open && (
            <div className="absolute right-6 top-16 w-44 bg-[#1b1d1a]/95 backdrop-blur-xl border border-gray-800 rounded-2xl shadow-2xl z-50 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
              <div className="px-4 py-3 border-b border-gray-800/50 flex items-center gap-3 bg-white/5">
                <div className={`h-8 w-8 rounded-full flex items-center justify-center border ${role === 'superadmin' ? 'border-green-500/50 bg-green-500/10' : 'border-blue-500/50 bg-blue-500/10'
                  }`}>
                  <FiUser className={role === 'superadmin' ? 'text-green-400' : 'text-blue-400'} size={14} />
                </div>
                <div>
                  <p className="text-sm font-bold text-white truncate capitalize leading-none">{role || 'User'}</p>
                </div>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleLogout();
                }}
                className="flex items-center gap-3 w-full px-4 py-3 text-sm text-red-500 hover:bg-red-500/10 transition-colors"
              >
                <FiLogOut size={16} />
                <span className="font-bold"> Logout</span>
              </button>
            </div>
          )}
        </div>


      </div>



      {/* Tabs */}
      <div className="mt-6 w-full overflow-x-auto">
        <div className="bg-[#1b1d1a] rounded-full px-3 py-2 flex gap-2 items-center shadow-lg border border-gray-600 w-max mx-auto md:mx-0">
          {filteredTabs.map((tab) => {
            const active = location.pathname === tab.to;

            return (
              <Link key={tab.to} to={tab.to} className="no-underline">
                <span
                  className={`flex items-center gap-2 rounded-full px-4 py-2 text-xs sm:text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-300
                  ${active
                      ? "text-green-400 bg-green-500/10 shadow-[0_0_15px_rgba(34,197,94,0.2)]"
                      : "text-gray-400 hover:text-green-300 hover:bg-white/5"
                    }`}
                >
                  {tab.icon}
                  <span className="hidden sm:inline">{tab.label}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>

    </>
  );
}
